module.exports = __webpack_public_path__ + "img/sns_flickr.3426e995.png";